import { createSlice } from "@reduxjs/toolkit";
import { ITemplateDocGroup } from "../../@types/supplierProfile";

type SupplierState = {
  supplier: {
    email: string;
    found: boolean;
    id: string;
    isDeleted: boolean;
    name: string;
    isOnboardingDone: boolean;
    isOnBoardingCompleted: boolean;
    approvalStatus: number;
    customOnboardingTemplate: string;
    customSupplierDocListTemplate: string | null;
    isPaymentModuleEnabled: boolean;
    isManualDocumentModuleEnabled: boolean;
    currency: string;
    address: string;
    reason: String;
    obResetReason: string;
    customTheme: string;
    openPOPredefinedFieldName: string;
    enableManualFromUIV2: boolean;
    templateDocs: ITemplateDocGroup[] | null;
  };
};

const initialState: SupplierState = {
  supplier: {
    email: "",
    found: false,
    id: "",
    isDeleted: false,
    name: "",
    isOnboardingDone: false,
    isOnBoardingCompleted: false,
    approvalStatus: 0,
    customOnboardingTemplate: "",
    customSupplierDocListTemplate: null,
    isPaymentModuleEnabled: false,
    isManualDocumentModuleEnabled: false,
    enableManualFromUIV2: false,
    address: "",
    currency: "",
    reason: "",
    obResetReason: "",
    customTheme: "",
    openPOPredefinedFieldName: "",
    templateDocs: null,
  },
};

const slice = createSlice({
  name: "Supplier",
  initialState,
  reducers: {
    loginSupplierAction(state, action) {
      const {
        email,
        found,
        id,
        isDeleted,
        name,
        isOnboardingDone,
        isOnBoardingCompleted,
        approvalStatus,
        customOnboardingTemplate,
        customSupplierDocListTemplate,
        isPaymentModuleEnabled,
        isManualDocumentModuleEnabled,
        currency,
        address,
        reason,
        obResetReason,
        customTheme,
        openPOPredefinedFieldName,
        enableManualFromUIV2,
        templateDocs,
      } = action.payload;

      state.supplier = {
        email,
        found,
        id,
        isDeleted,
        name,
        isOnboardingDone,
        isOnBoardingCompleted,
        approvalStatus: approvalStatus ?? 0,
        customOnboardingTemplate,
        customSupplierDocListTemplate,
        isPaymentModuleEnabled,
        isManualDocumentModuleEnabled,
        currency,
        address,
        reason,
        obResetReason: obResetReason ?? "",
        enableManualFromUIV2,
        customTheme: customTheme,
        openPOPredefinedFieldName,
        templateDocs: templateDocs ?? null,
      };
    },

    logoutSupplierAction(state) {
      state.supplier = {
        email: "",
        found: false,
        id: "",
        isDeleted: false,
        name: "",
        isOnboardingDone: false,
        isOnBoardingCompleted: false,
        approvalStatus: 0,
        customOnboardingTemplate: "",
        customSupplierDocListTemplate: null,
        isPaymentModuleEnabled: false,
        isManualDocumentModuleEnabled: false,
        enableManualFromUIV2: false,
        customTheme: "",
        address: "",
        currency: "",
        reason: "",
        obResetReason: "",
        openPOPredefinedFieldName: "",
        templateDocs: null,
      };
    },

    updateSupplierAction(state, action) {
      const { email, found, id, isDeleted, name, currency, address } =
        action.payload;

      state.supplier = {
        ...state.supplier,
        email,
        found,
        id,
        isDeleted,
        name,
        currency,
        address,
      };
    },

    updateSupplierOnboardingAction(state, action) {
      const {
        email,
        found,
        id,
        isDeleted,
        name,
        isOnboardingDone,
        isOnBoardingCompleted,
        approvalStatus,
        currency,
        address,
        reason,
      } = action.payload;

      state.supplier = {
        ...state.supplier,
        email,
        found,
        id,
        isDeleted,
        name,
        isOnboardingDone,
        isOnBoardingCompleted,
        approvalStatus: approvalStatus ?? state.supplier.approvalStatus,
        currency,
        address,
        reason,
      };
    },
  },
});

export default slice.reducer;

export const {
  loginSupplierAction,
  logoutSupplierAction,
  updateSupplierAction,
  updateSupplierOnboardingAction,
} = slice.actions;
